import API from 'services/API/index';

export default function deleteBankCard(cardId) {
  return API.request({
    method: 'DELETE',
    url: `/pay/cards/${cardId}`,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
}
